import React from 'react';

const MarkdownLinkRenderer = props => (
  <a href={props.href} target="_blank" className={props.className}>
    {props.children}
  </a>
);

export default MarkdownLinkRenderer;
